module.exports = __webpack_public_path__ + "static/media/vg.207949f4.svg";